import { BaseAction } from '../../store/actions';
import { RegisterInfo } from '../../shared/models/register';

export enum InternalSignUpActions {
  InternalSignUpRequest = '[Internal SignUp] Request',
  InternalSignUpSuccess = '[Internal SignUp] Success',
  InternalSignUpFailed = '[Internal SignUp] Failed',
}

export interface InternalSignUpPayload {
  orgName: string;
  adminFirstName: string;
  adminLastName: string;
  adminEmail: string;
  adminPhone: string;
  password: string;
  info: RegisterInfo;
  shard: string;
}

export class InternalSignUpRequest implements BaseAction<InternalSignUpActions> {
  readonly type = InternalSignUpActions.InternalSignUpRequest;

  constructor(public readonly payload: InternalSignUpPayload) {}
}

export class InternalSignUpSuccess implements BaseAction<InternalSignUpActions> {
  readonly type = InternalSignUpActions.InternalSignUpSuccess;
}

export class InternalSignUpFailed implements BaseAction<InternalSignUpActions> {
  readonly type = InternalSignUpActions.InternalSignUpFailed;

  constructor(public readonly payload: string) {}
}

export type InternalSignUpAction = 
  | InternalSignUpRequest 
  | InternalSignUpSuccess 
  | InternalSignUpFailed;
